"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayServerLaneAPI = void 0;
const shared_1 = require("@getgreenline/shared");
const WorldpayServerCommonAPI_1 = require("../WorldpayServerCommonAPI");
class WorldpayServerLaneAPI extends WorldpayServerCommonAPI_1.WorldpayServerCommonAPI {
    constructor(params) {
        super(params.appSpecificHeaders);
        this.createLaneAsync = async ({ requestId, tenantSpecificHeaders, callbackUrl, payload, }) => {
            const headers = {
                ...this.getHeaders(requestId, tenantSpecificHeaders),
                'tp-isasync': true,
            };
            if (callbackUrl)
                headers['tp-callback-url'] = callbackUrl;
            try {
                const asyncRes = await shared_1.axios.post(this.apiUrl, payload, {
                    headers,
                });
                const res = {
                    operationRetry: asyncRes.headers['operation-retry'],
                    resourceLocation: asyncRes.headers['resource-location'],
                };
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getLaneFromResourceLocation = async ({ requestId, tenantSpecificHeaders, resourceLocation, }) => {
            try {
                const res = await this.getResourceFromLocation({
                    requestId,
                    tenantSpecificHeaders,
                    resourceLocation,
                });
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getLane = async ({ requestId, tenantSpecificHeaders, laneId, }) => {
            try {
                const res = await shared_1.axios.get(`${this.apiUrl}/${laneId}`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getLanes = async ({ requestId, tenantSpecificHeaders, }) => {
            try {
                const res = await shared_1.axios.get(this.apiUrl, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.updateLane = async ({ requestId, tenantSpecificHeaders, laneId, payload, }) => {
            try {
                const res = await shared_1.axios.patch(`${this.apiUrl}/${laneId}`, payload, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                // Worldpay incorrectly lower-cases the first letter
                const language = (res.data.language.charAt(0).toUpperCase() +
                    res.data.language.slice(1));
                const updatedLane = {
                    ...res.data,
                    contactlessEmvEnabled: res.data.contactlessEmvEnabled === 'true',
                    contactlessMsdEnabled: res.data.contactlessEmvEnabled === 'true',
                    quickChipEnabled: res.data.contactlessEmvEnabled === 'true',
                    language,
                };
                return updatedLane;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.deleteLane = async ({ requestId, tenantSpecificHeaders, laneId, }) => {
            try {
                const res = await shared_1.axios.delete(`${this.apiUrl}/${laneId}`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.requestActivationCode = async ({ requestId, tenantSpecificHeaders, laneId, }) => {
            try {
                const res = await shared_1.axios.post(`${this.apiUrl}/${laneId}/activationCode`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getConnectionStatus = async ({ requestId, tenantSpecificHeaders, laneId, }) => {
            try {
                const res = await shared_1.axios.get(`${this.apiUrl}/${laneId}/connectionstatus`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getHeaders = (requestId, tenantSpecificHeaders) => {
            return this.getCommonHeaders(requestId, tenantSpecificHeaders);
        };
        this.apiUrl = `${params.baseUrl}/v1/lanes`;
    }
}
exports.WorldpayServerLaneAPI = WorldpayServerLaneAPI;
//# sourceMappingURL=WorldpayServerLaneAPI.js.map